import React from 'react'

export const EditIcon = props => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0504 3.00002L4.20878 10.2417C3.95045 10.5167 3.70045 11.0584 3.65045 11.4334L3.34211 14.1334C3.23378 15.1084 3.93378 15.775 4.90045 15.6084L7.58378 15.15C7.95878 15.0834 8.48378 14.8084 8.74211 14.525L15.5838 7.28335C16.7671 6.03335 17.3004 4.60835 15.4588 2.86668C13.6254 1.14168 12.2338 1.75002 11.0504 3.00002Z"
        stroke="#0C172C"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.9082 4.20801C10.2665 6.50801 12.1332 8.26634 14.4499 8.49967"
        stroke="#0C172C"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5 18.333H17.5"
        stroke="#0C172C"
        stroke-width="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
